import { motion } from "framer-motion";

// Line-by-line masked reveal. Pass `lines` as an array of strings; each renders
// on its own row with a translateY(100%) → 0 reveal within an overflow-hidden mask.
export default function RevealText({
  lines,
  as: Tag = "h1",
  className = "",
  delay = 0,
  stagger = 0.08,
  duration = 1.05,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-wrap">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
